// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import scrubPathSummary from './scrubPathSummary'

// arr is an array of path summaries from API.
// unitType is the default unit which should be used when preparing this data.

const prepData = (arr, unitType) => {
  if (unitType === undefined) {
    throw new Error('Unit type is undefined for prepping the Path Summary data.')
  }

  return arr.map((d, i) => scrubPathSummary(d, i, unitType))
}

export default prepData
